<mat-progress-bar
  mode="determinate"
  [color]="passwordStrength | passwordStrengthColor"
  [value]="passwordStrength | passwordStrengthProgress"
></mat-progress-bar>

<div *ngIf="pwValue" class="password__strength" [ngClass]="passwordStrength | passwordStrengthColor">
  {{ passwordStrength | passwordStrengthText }}
</div>

<div class="password__tips">
  Password Tips:
  <ul>
    <li>use special characters (e.g. $, !, @)</li>
    <li>uppercase and lowercase characters</li>
    <li>10-64 characters in length</li>
  </ul>
</div>
